export default {
  SettingsPage: {
    settings: 'Settings',
  },
  SettingsTabs: {
    general: 'General',
    opsDashboard: 'Ops Dashboard',
    phlebotomistDashboard: 'Phlebotomist Dashboard',
    recruiterDashboard: 'Recruiter Dashboard',
    handlerDashboard: 'Handler Dashboard',
    donors: 'Donors',
  },
  GeneralSettings: {
    title: 'General Settings',
    description: 'Configure general application settings.',
  },
  DonorSettings: {
    fetchingError: 'Failed to load Donor Settings',
    save: 'Save Changes',
    cancel: 'Cancel',
    MicrochipSection: {
      title: 'Microchip Settings',
      description: 'Configure microchip related settings',
      price: 'Microchip price',
    },
    ValidationErrors: {
      required: 'Value is required',
      positive: 'Value must be greater than 0',
      number: 'Value must be a number',
    },
  },
  PhlebotomistDashboardSettings: {
    title: 'Phlebotomist Dashboard Settings',
    description: 'Configure phlebotomist dashboard settings.',
    debugTitle: 'Debug Settings',
    debugDescription: 'Show debug information on the phlebotomist dashboard.',
    showDebugLabel: 'Show Debug',
    saveSettings: 'Save Settings',
    settingsSaved: 'Settings saved successfully',
    notSaved: 'Not Saved',
    settingsJsonLabel: 'Settings JSON',
    excludeUsersTitle: 'Exclude Phlebotomists / Team Leads',
    excludeUsersDescription:
      'Select phlebotomists or team leads to exclude from all dashboard calculations, aggregations, and the phlebotomist filter dropdown.',
    excludeUsersPlaceholder: 'Select users to exclude...',
  },
  OpsDashboardSettings: {
    title: 'Ops Dashboard Settings',
    description: 'Configure operations dashboard settings.',
    debugTitle: 'Debug Settings',
    debugDescription: 'Show debug information on the operations dashboard.',
    showDebugLabel: 'Show Debug',
    saveSettings: 'Save Settings',
    notSaved: 'Not Saved',
    tabVisibilityTitle: 'Ops Tab Visibility',
    tabVisibilityDescription:
      'Configure tab visibility and data scope per role.',
  },
  HandlerDashboardSettings: {
    title: 'Handler Dashboard Settings',
    description: 'Configure handler dashboard settings.',
    comingSoon: 'Handler Dashboard settings coming soon.',
  },
  RecruiterDashboardSettings: {
    title: 'Recruiter Dashboard Settings',
    description: 'Configure recruiter dashboard settings.',
    debugTitle: 'Debug Settings',
    debugDescription: 'Show debug information on the recruiter dashboard.',
    showDebugLabel: 'Show Debug',
    workingDaysTitle: 'Working Days',
    workingDaysDescription:
      'Select dates to exclude from recruiter dashboard calculations.',
    daysOfWeekDescription: 'Configure working days-of-the-week',
    excludeDatesLabel: 'Exclude Dates',
    selectedDatesLabel: 'Selected Excluded Dates',
    noDatesSelected: 'No dates selected',
    clearAll: 'Clear All',
    showCalendar: 'Select Dates',
    hideCalendar: 'Done',
    monthlyGoalTitle: 'Daily Goal',
    monthlyGoalDescription: 'Set the daily pRBC collection goal.',
    dayPrbcGoalLabel: 'Daily pRBC Goal',
    quarterlyGoalTitle: 'Quarterly Goal Tracker',
    quarterlyGoalDescription:
      'Configure status thresholds for quarterly goal tracking.',
    statusBreakpointsLabel: 'Status Breakpoints',
    offtrackLabel: 'Offtrack',
    atRiskLabel: 'At Risk',
    onTrackLabel: 'On Track',
    saveSettings: 'Save Settings',
    notSaved: 'Not Saved',
    settingsJsonLabel: 'Settings JSON',
    roleRestrictionsTitle: 'Role-Based Filter Restrictions',
    roleRestrictionsDescription:
      'Limit dashboard data visibility based on user roles.',
    roleRestrictionsEnabledLabel: 'Limit data by user role',
    roleRestrictionsPerRoleLabel: 'Configure restrictions per role:',
    hideDashboardLabel: 'Hide Recruiter Dashboard',
    lockToRegionLabel: "Lock to user's region",
    lockToOfficeLabel: "Lock to user's office",
    activeDonorStatusesTitle: 'Active Donor Statuses',
    activeDonorStatusesDescription:
      'Select which donor statuses are considered "active" for pipeline health calculations.',
    pendingDonorStatusesTitle: 'Pending Donor Statuses',
    pendingDonorStatusesDescription:
      'Select which donor statuses are considered "pending" for pipeline health calculations.',
    approvedDonorStatusesTitle: 'Approved Donor Statuses',
    approvedDonorStatusesDescription:
      'Select which donor statuses are considered "approved" for pipeline health calculations.',
    activeLocationThresholdTitle: 'Active Location Threshold (Days)',
    activeLocationThresholdDescription:
      'A location is considered "active" if at least one donation was made there within this many days.',
  },
};
